import { render, staticRenderFns } from "./FilterResumoConsultorVendas.vue?vue&type=template&id=b846892e&scoped=true&"
import script from "./FilterResumoConsultorVendas.vue?vue&type=script&lang=js&"
export * from "./FilterResumoConsultorVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b846892e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VContainer,VMenu})
